import { render, staticRenderFns } from "./court-covarage-area.vue?vue&type=template&id=1742252b&"
import script from "./court-covarage-area.vue?vue&type=script&lang=js&"
export * from "./court-covarage-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports